import _ from 'lodash'

export default {
	name : 'messenger',
	data () {
		return {
			messages : []
		}
	},
	methods : {
		showMessage (data) {

			let vm = this

			var message = {
				id : _.uniqueId('message_'),
				content : data.message,
				type : data.type
			};

			setTimeout(function(){

				vm.deleteMessage( message.id )

			}, 20000);

			vm.messages.push(message)

		},
		deleteMessage (id) {

			let vm = this

			for( var i = 0; i < vm.messages.length; i++ ){

				if( vm.messages[i].id == id ){

					vm.messages.splice( i, 1 )

					break;

				}
			}

		}
	},
	created () {
		
		let vm = this

		vm.$root.$on('showMessage', (data) => {
		
			vm.showMessage(data)
		
		})

	}
}


// WEBPACK FOOTER //
// ./src/components/general/messenger/script.js